<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  appendTo="body"
  styleClass="reschedule-dialog"
  [breakpoints]="{ '576px': '100vw' }"
>
  <ng-template #header>
    <div class="header-content">
      <div class="flex align-items-start justify-content-between w-full gap-3">
        <div class="flex align-items-center gap-3">
          <div class="flex justify-content-center align-items-center dialog-header-icon">
            <i class="pi pi-calendar text-gray-700"></i>
          </div>
          <div class="flex flex-column gap-1">
            <div class="text-lg-semibold text-gray-900">Izmena termina</div>
            <div class="text-sm-regular text-gray-600">Promeni vreme termina u skladu sa dostupnošću.</div>
          </div>
        </div>
        <app-x-close stroke="#ADB0B8" width="12" height="12" class="cursor-pointer" (click)="onCancel()"></app-x-close>
      </div>
      <div class="header-divider"></div>
    </div>
  </ng-template>

  <div class="flex flex-column gap-4">
    <form [formGroup]="form" class="date-time-row">
      <app-field label="Datum" styleClass="text-sm-semibold text-gray-700">
        <app-calendar
          [formCtrl]="dateCtrl"
          [inline]="true"
          [ctrlShowTime]="false"
          [hideErrors]="true"
          [minDateCtrl]="minDate()"
          [maxDateCtrl]="maxDate()"
          [unavailableDays]="disabledDates()"
        ></app-calendar>
      </app-field>

      <app-field label="Vreme" styleClass="text-sm-semibold text-gray-700">
        @if (!dateCtrl.value) {
          <div class="time-empty text-sm-regular text-gray-500">Izaberite datum</div>
        } @else {
          <div class="time-slots">
            @for (interval of availableIntervals(); track interval.from) {
              <button
                type="button"
                class="time-slot"
                [class.selected]="isIntervalSelected(interval)"
                (click)="selectInterval(interval)"
              >
                {{ formatTime(interval.from) }} - {{ formatTime(interval.to) }}
              </button>
            }
          </div>
        }
      </app-field>
    </form>

    @if (details(); as d) {
      <div class="summary-card">
        <div class="text-sm-semibold text-gray-900 mb-2">Nov termin</div>
        <div class="summary-row">
          <div class="summary-item">
            <i class="pi pi-calendar text-gray-400"></i>
            <div class="flex flex-column">
              <div class="text-sm-regular text-gray-500 line-through">
                {{ formatShortSrDate(d.from!) }}
              </div>
              <div class="text-sm-semibold text-gray-900">
                {{ dateCtrl.value ? formatShortSrDate(dateCtrl.value) : '-' }}
              </div>
            </div>
          </div>
          <div class="summary-item">
            <i class="pi pi-clock text-gray-400"></i>
            <div class="flex flex-column">
              <div class="text-sm-regular text-gray-500 line-through">
                {{ formatTimeRange(d.from, d.to) }}
              </div>
              <div class="text-sm-semibold text-gray-900">
                {{ selectedTimeLabel() || '-' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <ng-template #footer>
    <div class="footer-content">
      <div class="footer-divider"></div>
      <div class="dialog-footer">
        <app-button [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.MD" (btnClicked)="onCancel()">
        <div class="text-sm-semibold text-gray-900">Otkaži</div>
      </app-button>
      <app-button
        [btnSeverity]="ButtonSeverity.PRIMARY"
        [btnSize]="ButtonSize.MD"
        [isBtnDisabled]="form.invalid"
        (btnClicked)="onSubmit()"
      >
        <div class="text-sm-semibold" [class.text-white]="!form.invalid" [class.text-gray-400]="form.invalid">Sačuvaj izmene</div>
      </app-button>
      </div>
    </div>
  </ng-template>
</p-dialog>
